import axios from "axios"
import { env } from '../constants'

/* LIST */
export const list = data => {
    const uri = `${env.startpoint}/admin/queue/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* ORGANIZATIONS — the points which really keep a queue */
export const organizations = () => {
    const uri = `${env.startpoint}/admin/queue/organizations`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(data => data.response)
}

/* GET — the whole card of one ticket */
export const get = data => {
    const uri = `${env.startpoint}/admin/queue/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* STATUS — вызвать, начать, завершить, неявка, отменить, вернуть в ожидание */
export const status = data => {
    const uri = `${env.startpoint}/admin/queue/status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* ASSIGN — the ticket is handed over to another master of the point */
export const assign = data => {
    const uri = `${env.startpoint}/admin/queue/assign`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}
